/**
 * Action de la partie dashboard
 */
export const GET_ALL_STATS = 'GET_ALL_STATS';

export const getAllStats = params => ({
  type: GET_ALL_STATS,
  payload: params
});

export const GET_SHIPPED_QUANTITIES = 'GET_SHIPPED_QUANTITIES';
export const GET_SHIPPED_QUANTITIES_SUCCESS = 'GET_SHIPPED_QUANTITIES_SUCCESS';
export const GET_SHIPPED_QUANTITIES_FAILURE = 'GET_SHIPPED_QUANTITIES_FAILURE';

export const getShippedQuantities = params => ({
  type: GET_SHIPPED_QUANTITIES,
  payload: params
});

export const GET_SHIPPED_QUANTITIES_TOP = 'GET_SHIPPED_QUANTITIES_TOP';
export const GET_SHIPPED_QUANTITIES_TOP_SUCCESS =
  'GET_SHIPPED_QUANTITIES_TOP_SUCCESS';
export const GET_SHIPPED_QUANTITIES_TOP_FAILURE =
  'GET_SHIPPED_QUANTITIES_TOP_FAILURE';

export const getShippedQuantitiesTop = params => ({
  type: GET_SHIPPED_QUANTITIES_TOP,
  payload: params
});

export const GET_AVERAGE_DELIVERY_DAYS = 'GET_AVERAGE_DELIVERY_DAYS';
export const GET_AVERAGE_DELIVERY_DAYS_SUCCESS =
  'GET_AVERAGE_DELIVERY_DAYS_SUCCESS';
export const GET_AVERAGE_DELIVERY_DAYS_FAILURE =
  'GET_AVERAGE_DELIVERY_DAYS_FAILURE';

export const getAverageDeliveryDays = params => ({
  type: GET_AVERAGE_DELIVERY_DAYS,
  payload: params
});

export const GET_AVERAGE_DELIVERY_DAYS_TOP = 'GET_AVERAGE_DELIVERY_DAYS_TOP';
export const GET_AVERAGE_DELIVERY_DAYS_TOP_SUCCESS =
  'GET_AVERAGE_DELIVERY_DAYS_TOP_SUCCESS';
export const GET_AVERAGE_DELIVERY_DAYS_TOP_FAILURE =
  'GET_AVERAGE_DELIVERY_DAYS_TOP_FAILURE';

export const getAverageDeliveryDaysTop = params => ({
  type: GET_AVERAGE_DELIVERY_DAYS_TOP,
  payload: params
});

export const GET_QUANTITIES_BY_STATE = 'GET_QUANTITIES_BY_STATE';
export const GET_QUANTITIES_BY_STATE_SUCCESS =
  'GET_QUANTITIES_BY_STATE_SUCCESS';
export const GET_QUANTITIES_BY_STATE_FAILURE =
  'GET_QUANTITIES_BY_STATE_FAILURE';

export const GET_SHIPPED_QUANTITIES_BY_CARRIER =
  'GET_SHIPPED_QUANTITIES_BY_CARRIER';
export const GET_SHIPPED_QUANTITIES_BY_CARRIER_SUCCESS =
  'GET_SHIPPED_QUANTITIES_BY_CARRIER_SUCCESS';
export const GET_SHIPPED_QUANTITIES_BY_CARRIER_FAILURE =
  'GET_SHIPPED_QUANTITIES_BY_CARRIER_FAILURE';

export const getShippedByCarrier = params => ({
  type: GET_SHIPPED_QUANTITIES_BY_CARRIER,
  payload: params
});

export const GET_SHIPPED_ITEMS_QUANTITIES = 'GET_SHIPPED_ITEMS_QUANTITIES';
export const GET_SHIPPED_ITEMS_QUANTITIES_SUCCESS =
  'GET_SHIPPED_ITEMS_QUANTITIES_SUCCESS';
export const GET_SHIPPED_ITEMS_QUANTITIES_FAILURE =
  'GET_SHIPPED_ITEMS_QUANTITIES_FAILURE';

export const getShippedItemsQuantities = params => ({
  type: GET_SHIPPED_ITEMS_QUANTITIES,
  payload: params
});

export const GET_PROCESSED_SHIPMENTS_NATURES_QUANTITIES =
  'GET_PROCESSED_SHIPMENTS_NATURES_QUANTITIES';
export const GET_PROCESSED_SHIPMENTS_NATURES_QUANTITIES_SUCCESS =
  'GET_PROCESSED_SHIPMENTS_NATURES_QUANTITIES_SUCCESS';
export const GET_PROCESSED_SHIPMENTS_NATURES_QUANTITIES_FAILURE =
  'GET_PROCESSED_SHIPMENTS_NATURES_QUANTITIES_FAILURE';

export const getProcessedShipmentsNaturesQuantities = params => ({
  type: GET_PROCESSED_SHIPMENTS_NATURES_QUANTITIES,
  payload: params
});

export const GET_PROCESSED_ITEMS_NATURES_QUANTITIES =
  'GET_PROCESSED_ITEMS_NATURES_QUANTITIES';
export const GET_PROCESSED_ITEMS_NATURES_QUANTITIES_SUCCESS =
  'GET_PROCESSED_ITEMS_NATURES_QUANTITIES_SUCCESS';
export const GET_PROCESSED_ITEMS_NATURES_QUANTITIES_FAILURE =
  'GET_PROCESSED_ITEMS_NATURES_QUANTITIES_FAILURE';

export const getProcessedItemsNaturesQuantities = params => ({
  type: GET_PROCESSED_ITEMS_NATURES_QUANTITIES,
  payload: params
});

export const GET_REASONS_QUANTITIES = 'GET_REASONS_QUANTITIES';
export const GET_REASONS_QUANTITIES_SUCCESS = 'GET_REASONS_QUANTITIES_SUCCESS';
export const GET_REASONS_QUANTITIES_FAILURE = 'GET_REASONS_QUANTITIES_FAILURE';

export const getReasonsQuantities = params => ({
  type: GET_REASONS_QUANTITIES,
  payload: params
});

export const GET_RECEPTION_QUANTITIES = 'GET_RECEPTION_QUANTITIES';
export const GET_RECEPTION_QUANTITIES_SUCCESS =
  'GET_RECEPTION_QUANTITIES_SUCCESS';
export const GET_RECEPTION_QUANTITIES_FAILURE =
  'GET_RECEPTION_QUANTITIES_FAILURE';

export const getReceptionQuantities = params => ({
  type: GET_RECEPTION_QUANTITIES,
  payload: params
});

export const GET_EXPECTED_PRODUCTS_QUANTITIES =
  'GET_EXPECTED_PRODUCTS_QUANTITIES';
export const GET_EXPECTED_PRODUCTS_QUANTITIES_SUCCESS =
  'GET_EXPECTED_PRODUCTS_QUANTITIES_SUCCESS';
export const GET_EXPECTED_PRODUCTS_QUANTITIES_FAILURE =
  'GET_EXPECTED_PRODUCTS_QUANTITIES_FAILURE';

export const getExpectedProductsQuantities = params => ({
  type: GET_EXPECTED_PRODUCTS_QUANTITIES,
  payload: params
});

export const GET_ACTUAL_PRODUCTS_QUANTITIES = 'GET_ACTUAL_PRODUCTS_QUANTITIES';
export const GET_ACTUAL_PRODUCTS_QUANTITIES_SUCCESS =
  'GET_ACTUAL_PRODUCTS_QUANTITIES_SUCCESS';
export const GET_ACTUAL_PRODUCTS_QUANTITIES_FAILURE =
  'GET_ACTUAL_PRODUCTS_QUANTITIES_FAILURE';

export const getActualProductsQuantities = params => ({
  type: GET_ACTUAL_PRODUCTS_QUANTITIES,
  payload: params
});

export const GET_PROCESSED_QUANTITIES = 'GET_PROCESSED_QUANTITIES';
export const GET_PROCESSED_QUANTITIES_SUCCESS =
  'GET_PROCESSED_QUANTITIES_SUCCESS';
export const GET_PROCESSED_QUANTITIES_FAILURE =
  'GET_PROCESSED_QUANTITIES_FAILURE';

export const getProcessedQuantities = params => ({
  type: GET_PROCESSED_QUANTITIES,
  payload: params
});

export const GET_MULTIPLE_EXCHANGES_QUANTITY =
  'GET_MULTIPLE_EXCHANGES_QUANTITY';
export const GET_MULTIPLE_EXCHANGES_QUANTITY_SUCCESS =
  'GET_MULTIPLE_EXCHANGES_QUANTITY_SUCCESS';
export const GET_MULTIPLE_EXCHANGES_QUANTITY_FAILURE =
  'GET_MULTIPLE_EXCHANGES_QUANTITY_FAILURE';

export const getMultipleExchangesQuantity = params => ({
  type: GET_MULTIPLE_EXCHANGES_QUANTITY,
  payload: params
});

export const GET_EXCHANGES_FOLLOWED_BY_REFUNDS_QUANTITY =
  'GET_EXCHANGES_FOLLOWED_BY_REFUNDS_QUANTITY';
export const GET_EXCHANGES_FOLLOWED_BY_REFUNDS_QUANTITY_SUCCESS =
  'GET_EXCHANGES_FOLLOWED_BY_REFUNDS_QUANTITY_SUCCESS';
export const GET_EXCHANGES_FOLLOWED_BY_REFUNDS_QUANTITY_FAILURE =
  'GET_EXCHANGES_FOLLOWED_BY_REFUNDS_QUANTITY_FAILURE';

export const getExchangesFollowedByRefundsQuantity = params => ({
  type: GET_EXCHANGES_FOLLOWED_BY_REFUNDS_QUANTITY,
  payload: params
});
